(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7673],{

/***/ 6478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/ebay-updated-fees/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-02-22",
      tag: "eBay",
      title: "eBay's 2022 Seller Price Increases and Fees",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "With millions of transactions every day, selling on eBay has become highly competitive. Beyond marketing your products, you have to consider the commission fees, shipping costs, and other charges that can impact your total earnings."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "As part of eBay\u2019s Winter Seller Update, they announced a price hike across the different payments on the website. From Final Value Fees, Standard Selling, Monthly Subscription to other important calculation methods, here is what you should expect starting March 1, 2022."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Changes in Standard Selling Fees"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Currently, eBay accounts pay for any final value fee between 3.5% to 12.55%, with the addition of $0.30 per order across most categories. Keep in mind that all these still depend on the subscription model of the seller."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "However, with the new update, items sold after March 1, 2022, are now 12.9% + $0.30 for every order on most categories. This means 2.35% on the sale portion made over $7,500."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "It is raised to 14.6% for books, magazines, films, and music types (except vinyl records) and can go high up to 15% for watches, accessories, and other parts (6.5% for sales over $1,000 while 3% for over $7,500 sales)."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "As for Monthly Store Subscription Fees, it is still the Final Value Fee % + $0.30. However, from the 11.7% on most categories, it is now raised to 12%. Similar to the previous fees, it goes up to 14.6% for items categorized under films, TV, music, books, and magazines."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Other categories retained the same fees, such as women\u2019s handbags (13%), business and industrial products like heavy equipment (2.5%), watches and parts (12.5%), and NFTs (5%)."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["You can check the exhaustive list", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://pages.ebay.com/seller-center/seller-updates/2022-winter/fees-update.html#m17-1-tb1",
          children: "here"
        }), "."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Final Value Fee"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Among the most crucial hike to note is the Final Value Fee. This covers both the commission and the payment processing fees. You can see this on the total transaction once a sale has been made. This includes shipping and, of course, the sales tax that buyers shoulder."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["The total amount is calculated depending on the cheapest domestic option you have (apart from your 1-day or international shipping). But if you don\u2019t have this, then the total amount is based on which service the buyer opted to have.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If your item is not coming from the US, then the total cost of the sale is only dependent on your buyer\u2019s shipping option. This is why you have to be smart in pricing your items in the first place to make sure you are not getting the short end of the stick."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "The New Promoted Listing Standard"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "There are different \u201CPromoted Listing\u201D types on eBay, which helps sellers increase their chances of closing sales. These are the Promoted Listing Standard, Promoted Listing Express, and Promoted Listing Advanced."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["The first type is the most common and easiest to understand. This only means getting your items noticed by more potential buyers across the website once your listings are in the Advertising Dashboard. You can activate this by using the \u201CStandard Campaign\u201D quick listing tool, promoting listings manually, or bulk via", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://www.ebay.com/sh/lst/active",
          children: "Seller Hub Active Listings"
        }), "."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The system determines which of your items will be promoted and shown to eBay users. The fees range from 1% to 100% of the item\u2019s sale price. Take note that the higher your \u201Cad rate\u201D is (how much you want to pay for the promotion), the more you increase your exposure to other buyers."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The website also suggests your ad rates, but this is calculated based on your account\u2019s past performance, item attributes, seasonality or demand of the items, and current competition of your listings."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "You don\u2019t need to worry about the cost of high ad rates. This is because you will only get charged when a buyer clicks on your promoted listing and purchases the item within 30 days."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Along with the Winter Seller Update, eBay has a new \u201CCampaign Dashboard.\u201D This means you can easily edit your existing campaigns without the additional effort spent editing from the 3-step campaign flow."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The update also allows you to filter and gain insights into what else you can improve to promote your listings. However, note that this is not available for Automated Campaigns or those that automatically update. You have to edit directly from your dashboard manually."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "On Subtitle Listings"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "For those unfamiliar, adding subtitle listings to your main one only means having additional descriptions about your items. This can include details such as the brand, item condition and benefits, model number, and other specifications. This is only visible when the potential buyer views your listing but also when they do an \u201Cadvanced search.\u201D"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "With the new update, having Subtitle Listings now costs you $0.50. This also applies to those with starting prices for auction or Buy It Now types up to $150."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Initially, the fee was $1 for auction listings, but now, it is changed to $1.50. On the other hand, fixed price listings are now $2, which was $1.50 before."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Given this price increase, you should evaluate first if you need to do Subtitle Listings, whether in the short or long term.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "A Note on Below Standard Sellers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "eBay thrives on delivering the best experience for both buyers and sellers. Hence, they also increase the additional Final Value Fee from 5% to 6%. This applies to those who don\u2019t meet the minimum seller performance, at least in the US."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Naturally, this doesn\u2019t apply to those in the eBay Top Rated Sellers and those in the Above Standard levels. You can check your status from the Seller Dashboard."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/ebay-updated-fees.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "eBay's 2022 Seller Price Increases and Fees"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "From Final Value Fees, Standard Selling, Monthly Subscription to other important calculation methods, here is what you should expect starting March 1, 2022."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/ebay-updated-fees"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/ebay-updated-fees"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "eBay's 2022 Seller Price Increases and Fees"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "From Final Value Fees, Standard Selling, Monthly Subscription to other important calculation methods, here is what you should expect starting March 1, 2022."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "February 22nd, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "February 22nd, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "eBay"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 35702:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/ebay-updated-fees",
      function () {
        return __webpack_require__(6478);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(35702); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);